import { HomeyColors } from '../../theme/HomeyColors';
import { type AppProps } from './AppsStore';

export class AppUtils {
  static defaultAppBackgroundColor = HomeyColors.getColorForUri('homey:manager:apps');

  static getBackgroundColor(app?: AppProps) {
    if (app == null) {
      return this.defaultAppBackgroundColor;
    }

    // @ts-expect-error
    return app.brandColor ?? app.color;
  }
}
